import { Modal } from "native-base";

export default Modal;